import "./comboSettings.styles.scss";
const ComboSettings = () => {
  return (
    <div className="combo-settings-container">
      combos
      <div className="combo-settings-menu"></div>
      <div className="combo-settings-custom"></div>
    </div>
  );
};
export default ComboSettings;
